import apiClient from "./client";
import type { GetUsersParams, UsersListResponse } from "../types/user";

export const getUsers = async (
  params: GetUsersParams
): Promise<UsersListResponse> => {
  const { data } = await apiClient.get<UsersListResponse>("/users", { params });
  return data;
};
